import { defineMessages } from 'react-intl';

export const scope = 'app.components.PersonalizedSections';

export default defineMessages({
  // Left panel — Add to favorites
  addToListTitle: {
    id: `${scope}.addToListTitle`,
    defaultMessage: 'Thêm vào danh sách?',
  },
  addToListSubtitle: {
    id: `${scope}.addToListSubtitle`,
    defaultMessage: 'Bạn mua các sản phẩm này thường xuyên nhưng chưa lưu',
  },
  addAllBtn: {
    id: `${scope}.addAllBtn`,
    defaultMessage: 'Thêm tất cả',
  },
  // Right panel — Recommended products
  recommendedTitle: {
    id: `${scope}.recommendedTitle`,
    defaultMessage: 'Sản phẩm đề xuất',
  },
  recommendedSubtitle: {
    id: `${scope}.recommendedSubtitle`,
    defaultMessage: 'Được mua nhiều nhất trong danh mục kinh doanh của bạn.',
  },
  viewAll: {
    id: `${scope}.viewAll`,
    defaultMessage: 'Xem tất cả',
  },
  addItemToFavorite: {
    id: `${scope}.addItemToFavorite`,
    defaultMessage: 'Đã thêm sản phẩm vào yêu thích!',
  },
  addAllItemToFavorite: {
    id: `${scope}.addAllItemToFavorite`,
    defaultMessage: 'Đã thêm tất cả sản phẩm vào yêu thích!',
  },
  failToAddFavorite: {
    id: `${scope}.failToAddFavorite`,
    defaultMessage: 'Thêm sản phẩm vào yêu thích thất bại!',
  },
  addedToFavorite: {
    id: `${scope}.addedToFavorite`,
    defaultMessage: 'Đã thêm vào yêu thích',
  },
  addedToFavoriteSubText: {
    id: `${scope}.addedToFavoriteSubText`,
    defaultMessage: 'Mua lại thật dễ dàng ở những lần sau 🎉',
  },
  goToFavorite: {
    id: `${scope}.goToFavorite`,
    defaultMessage: 'Vào yêu thích',
  },
  addedToCart: {
    id: `${scope}.addedToCart`,
    defaultMessage: 'Thêm sản phẩm vào giỏ hàng thành công',
  },
  failToAddToCart: {
    id: `${scope}.failToAddToCart`,
    defaultMessage: 'Thêm sản phẩm vào giỏ hàng thất bại',
  },
});
